var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-aligncnter",attrs:{"id":"container"}},[_c('i',{class:_vm.getCurrIcon()}),_c('div',{staticStyle:{"margin-left":"6px"}},[_vm._v(_vm._s(_vm.gaodeWeather.weather))]),(!!_vm.gaodeWeather.temperature)?_c('div',{staticStyle:{"margin-left":"6px"}},[_vm._v(_vm._s(_vm.gaodeWeather.temperature)+"°C")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }